import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import MoneyflowInvalidOfferDialogComponent from './MoneyflowInvalidOfferDialog.Component';
import { InvoicingMessageType } from '../types';
import { t, useLocalization } from '../../../../../../shared/components/l10n/l10n';
import MoneyflowLoadingDialog from './MoneyflowLoadingDialog';

export default function MoneyflowMissingDefaultEinvoiceDialog() {
    const location = useLocation();
    const navigate = useNavigate();
    const loadingTexts = useLocalization(textIds);

    const hide = () => navigate(location.pathname);
    const open = location.hash === '#moneyflow-missing-defaulteinvoice';

    if (loadingTexts) {
        return <MoneyflowLoadingDialog open={open} hide={hide} />;
    }

    return (
        <MoneyflowInvalidOfferDialogComponent
            open={open}
            hide={hide}
            messages={[
                { type: InvoicingMessageType.Error, message: t`FORM_BOOKANDSEND_ERRORS_MONEYFLOW_MISSINGDEFAULTEINVOICING` },
            ]}
            hasError
        />
    );
}

const textIds = [
    'FORM_BOOKANDSEND_MONEYFLOW_HEADER_NOTQUALIFIED',
    'FORM_BOOKANDSEND_ERRORS_MONEYFLOW_MISSINGDEFAULTEINVOICING',
    'SHARED_FORM_OK',
];
